import { render, staticRenderFns } from "./newsSetting.vue?vue&type=template&id=096e60bc&scoped=true"
import script from "./newsSetting.vue?vue&type=script&lang=js"
export * from "./newsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096e60bc",
  null
  
)

export default component.exports